import { useEffect } from 'react';
import type { RefObject } from 'react';
import { soundEngine } from '@/shared/lib/soundEngine';

/**
 * useFutebolSounds — registra volume e mute do Player na soundEngine.
 *
 * Deve ser montado uma única vez em Player.tsx.
 * Mute e volume 0 silenciam os efeitos no momento de cada play.
 */
export function useFutebolSounds(
  playerVolumeRef: RefObject<number>,
  playerMutedRef?: RefObject<boolean>,
): void {
  useEffect(() => {
    soundEngine.setVolumeRef(playerVolumeRef);
    if (playerMutedRef) soundEngine.setMutedRef(playerMutedRef);
  }, [playerVolumeRef, playerMutedRef]);
}
